module.exports = __webpack_public_path__ + "img/d.f569627c.png";